export interface TrnsxTokenRecord {
    id: string;
    gift_code: string;
    CSL_CLOSING_BALANCE: number;
    first_name: string;
    last_name: string;
    company_name: string;
    customer_email: string;
    recipient: string;
    mall: string;
    mall_address: string;
    created_at: string;
    action_created_by: string;
    language?: string;
    type?: string;
}

export const normalizeRecord = (record: Partial<TrnsxTokenRecord>): TrnsxTokenRecord => {
    if (!record) {
        return null;
    }
    
    return {
        id: record.id || '',
        gift_code: record.gift_code || '',
        CSL_CLOSING_BALANCE: record.CSL_CLOSING_BALANCE || 0,
        first_name: record.first_name || '',
        last_name: record.last_name || '',
        company_name: record.company_name || '',
        customer_email: record.customer_email || '',
        recipient: record.recipient || '',
        mall: record.mall || '',
        mall_address: record.mall_address || '',
        created_at: record.created_at || new Date().toISOString(),
        action_created_by: record.action_created_by || '',
        language: record.language || 'EN',
        type: record.type || 'b2c',
    };
};